import "./GetAQuote.module.css";
import Header from "@/reusable_sections/Header";
import ProjectInquiry from "./sections/ProjectInquiry";
import OurServiceTerritory from "./sections/OurServiceTerritory";
import Footer from "@/reusable_sections/Footer";
export default function GetAQuotePage() {
  return <div>
      <Header />
      <ProjectInquiry />
      <OurServiceTerritory />
      <Footer />
    </div>;
}